// Search

import {
  applyComparisonOperator,
  applyDateRangeFilter,
  parseFilters,
} from '../../../libs/filter.lib'
import {
  QueryStringFilter,
  QueryStringSort,
} from '../../../models/query-string.model'
import {
  ActivityField,
  ActivitySearchParams,
  ActivitySortField,
} from '../models/activity-search.model'

export function parseActivityFilters(
  params: ActivitySearchParams,
  filters: ActivitySearchParams,
): ActivitySearchParams {
  return parseFilters(params, filters, activityFilterParams)
}

export function activityFilterParams(
  params: ActivitySearchParams,
  filter: QueryStringFilter<ActivityField>,
): ActivitySearchParams {
  const searchParams: ActivitySearchParams = {}
  const value = Array.isArray(filter.value)
    ? filter.value.length
      ? filter.value[0]
      : undefined
    : filter.value

  switch (filter.field) {
    case '_id':
      if (filter.operator === '=') {
        searchParams['_id'] = filter.value
      }
      break
    case 'activity._id':
      if (filter.value !== null) {
        searchParams['activity._id'] = filter.value
      }
      break
    case 'activity.code':
      if (filter.value !== null) {
        searchParams['activity.code'] = filter.value
      }
      break
    case 'code':
      if (filter.value !== null) {
        searchParams.code = filter.value
      }
      break
    case 'context._id':
      if (filter.value !== null) {
        searchParams['context._id'] = filter.value
      }
      break
    case 'context.code':
      if (filter.value !== null) {
        searchParams['context.code'] = filter.value
      }
      break
    case 'isDisabled':
      if (filter.value !== null) {
        searchParams.isDisabled = filter.value
      }
      break
    case 'label':
      if (filter.value !== null) {
        searchParams.label = filter.value
      }
      break
    case 'isLast':
      searchParams.isLast = filter.value
      break
    case 'status':
      if (filter.value !== null) {
        searchParams['lastExecution.status'] = filter.value
      }
      break
    case 'type':
      if (filter.value !== null) {
        searchParams['lastExecution.type'] = filter.value
      }
      break
    case 'cron':
      if (filter.value !== null) {
        searchParams.cron = filter.value
      }
      break
    case 'createdAt':
      if (filter.operator === 'between') {
        Object.assign(
          searchParams,
          applyDateRangeFilter(
            'lastExecution.createdAt',
            Array.isArray(filter.value) ? (filter.value as Date[]) : [],
            searchParams,
          ),
        )
        break
      }
      Object.assign(
        searchParams,
        applyComparisonOperator(
          'lastExecution.createdAt',
          filter.operator,
          value,
          searchParams,
        ),
      )
      break
    case 'finishedAt':
      if (filter.operator === 'between') {
        Object.assign(
          searchParams,
          applyDateRangeFilter(
            'lastExecution.finishedAt',
            Array.isArray(filter.value) ? (filter.value as Date[]) : [],
            searchParams,
          ),
        )
        break
      }
      Object.assign(
        searchParams,
        applyComparisonOperator(
          'lastExecution.finishedAt',
          filter.operator,
          value,
          searchParams,
        ),
      )
      break
  }

  return {
    ...params,
    ...searchParams,
  }
}

export function activitySortParams(
  params: ActivitySearchParams,
  sort: QueryStringSort<ActivitySortField>,
): ActivitySearchParams {
  const searchParams: ActivitySearchParams = {}

  switch (sort.field) {
    case 'createdAt':
      searchParams.sort = 'createdAt'
      searchParams.order = sort.order
      break
    case 'finishedAt':
      searchParams.sort = 'finishedAt'
      searchParams.order = sort.order
      break
  }

  return {
    ...params,
    ...searchParams,
  }
}
